// Persisted the same way as chatPreferences.js - localStorage survives across
// sessions in the CEF profile, no server round trip needed for a purely
// client-side UI convenience.
const STORAGE_KEY = 'skymp5-emote-favorites';
export const FAVORITE_SLOT_COUNT = 9;

export function loadFavorites(): (string | null)[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return new Array(FAVORITE_SLOT_COUNT).fill(null);
    const result = parsed.slice(0, FAVORITE_SLOT_COUNT).map((v) => (typeof v === 'string' ? v : null));
    while (result.length < FAVORITE_SLOT_COUNT) result.push(null);
    return result;
  } catch (e) {
    return new Array(FAVORITE_SLOT_COUNT).fill(null);
  }
}

export function saveFavorites(favorites: (string | null)[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
  } catch (e) { }
}
